<template>
  <BlogPostLayout>
    <template #image>
      <BlogHeader
        :title="postData.title"
        :excerpt="postData.excerpt"
        :image="postData.image"
        :author="postData.author"
        :date="postData.date"
        :updatedAt="postData.updatedAt"
        :categories="postData.categories"
        :readTime="postData.readTime"
      />
    </template>
    <template #content>
      <article class="blog-content" lang="es">
        <section class="intro">
          <p>
            Añadir fotos de 360° a tu Perfil de Google Business es una de las
            acciones de marketing local más efectivas y de menor coste
            disponibles para cualquier negocio. Los perfiles con fotos de 360°
            reciben <strong>42 % más solicitudes de cómo llegar</strong> y
            <strong>35 % más clics al sitio web</strong> que los perfiles con
            fotos estándar. Esta guía paso a paso explica cómo configurar un
            tour virtual en Google Business, qué fotografiar y cómo maximizar su
            impacto en la búsqueda local.
          </p>
          <p>
            La prueba gratuita de Travvir incluye la creacion de tours, el alojamiento con enlace para compartir, la insercion iframe y las e-visitas, y las herramientas de pano a imagen y pano a video son siempre gratuitas. Descarga la app de Travvir para empezar.
          </p>
        </section>

        <section>
          <h2>¿Qué es un Tour Virtual de Google Business?</h2>

          <h3>Cómo Funciona</h3>
          <p>
            Un tour virtual de Google Business es una colección de fotos de 360°
            vinculadas a tu Perfil de Google Business que aparecen directamente
            en Google Search y Google Maps cuando alguien busca tu negocio o lo
            encuentra en un resultado de búsqueda local. Los clientes pueden
            hacer clic en "Ver fotos" → seleccionar "360°" y recorrer
            virtualmente tu negocio sin salir de Google.
          </p>

          <h3>Dónde Aparecen</h3>
          <p>
            <strong>Panel de conocimiento de Google Search:</strong> Cuando
            alguien busca el nombre de tu negocio, las fotos de 360° aparecen en
            el panel del Perfil de Empresa a la derecha.
            <strong>Ficha en Google Maps:</strong> Las fotos de 360° aparecen en
            la galería de fotos marcadas con "Ver interior" o "360°".
            <strong>Integración con Google Street View:</strong> Tus fotos de
            360° interiores se conectan con la red Street View existente,
            haciendo que tu negocio sea descubrible a través de exploraciones
            del barrio.
          </p>
        </section>

        <section>
          <h2>Requisitos para Añadir Fotos de 360°</h2>

          <h3>Lo que Necesitas</h3>
          <ul>
            <li>
              <strong>Un Perfil de Google Business verificado</strong> — si aún
              no has verificado tu ficha, completa ese paso primero
            </li>
            <li>
              <strong>La aplicación Travvir o una cámara de 360°</strong> —
              Travvir convierte las fotos de tu smartphone en contenido de 360°
              compatible con Google
            </li>
            <li>
              <strong>La aplicación Google Maps</strong> en tu smartphone para
              cargar las fotos directamente
            </li>
          </ul>

          <h3>Qué Fotografiar</h3>
          <p>Prioriza las áreas de mayor impacto visual para los clientes:</p>
          <ul>
            <li>
              <strong>Entrada / recepción</strong> — primera impresión que el
              cliente verá
            </li>
            <li>
              <strong>Sala principal o área de servicio</strong> — muestra la
              distribución y el ambiente
            </li>
            <li><strong>Zona de espera o lobby</strong> si aplica</li>
            <li>
              <strong>Áreas de productos destacados</strong> — escaparate, sala
              de exposición
            </li>
          </ul>
        </section>

        <section>
          <h2>Cómo Subir el Tour a Google Business</h2>
          <ol>
            <li>
              Abre la aplicación <strong>Google Maps</strong> en tu smartphone
            </li>
            <li>Busca tu negocio y accede a tu ficha</li>
            <li>
              Toca <strong>"Añadir fotos"</strong> → selecciona
              <strong>"360°"</strong>
            </li>
            <li>
              Sube las fotos de 360° que creaste con Travvir o tu cámara de 360°
            </li>
            <li>
              Google procesará las fotos (24–48 horas) antes de que aparezcan en
              tu ficha pública
            </li>
          </ol>
        </section>

        <section>
          <h2>Impacto en el SEO Local</h2>
          <p>
            Google favorece los perfiles de negocio con contenido rico y
            actualizado. Añadir un tour virtual de 360° es una señal de calidad
            que puede mejorar tu posición en las búsquedas locales,
            especialmente para categorías competitivas como restaurantes,
            hoteles, gimnasios y locales comerciales.
          </p>
          <p>
            Además, los perfiles con fotos de 360° generan más interacción — más
            tiempo en la ficha, más clics y más solicitudes de cómo llegar — lo
            que a su vez refuerza tu posicionamiento local de forma orgánica.
          </p>
        </section>

        <section>
          <h2>Preguntas frecuentes</h2>

          <h3>¿Las herramientas de pano a imagen y pano a video son realmente gratis?</h3>
          <p>
            Sí. Las herramientas de pano a imagen y pano a video son siempre gratuitas en la app de Travvir.
          </p>
        </section>

        <section>
          <h2>Conclusión</h2>
          <p>
            Un tour virtual 360° fortalece tu ficha de Google Business y tu SEO local con una inversión mínima. La prueba gratuita de Travvir incluye la creacion de tours, el alojamiento con enlace para compartir, la insercion iframe y las e-visitas, y las herramientas de pano a imagen y pano a video son siempre gratuitas. Descarga la app de Travvir para empezar.
          </p>
        </section>
        <section class="continue-reading">
          <h2>Seguir Leyendo</h2>
          <ul>
          <li><a href="/blog/es/tour-virtual-google-street-view">Tour Virtual de Google Street View: Crear y Publicar en 2026</a></li>
          <li><a href="/blog/es/fotos-360-seo-local">Fotos 360° y SEO Local: Mejora Tu Posicionamiento en Google</a></li>
          <li><a href="/blog/es/tour-virtual-negocio-local">Tour Virtual para Negocios Locales: Por Qué lo Necesitas en 2026</a></li>
          <li><a href="/blog/es/integrar-tour-virtual-sitio-web">Cómo Integrar un Tour Virtual 360° en tu Sitio Web 2026</a></li>
          <li><a href="/blog/es/crear-tour-virtual-gratis">Cómo Crear un Tour Virtual Gratis en 2026</a></li>
          <li><a href="/blog/es/tour-virtual-360-guia-completa">Tour Virtual 360°: Guía Completa para Principiantes (2026)</a></li>
          </ul>
        </section>



        <RelatedPosts
          :currentSlug="postData.slug"
          :currentCategories="postData.categories"
        />
      </article>
    </template>
  </BlogPostLayout>
</template>

<script setup>
import blogPostsData from "~/data/blogPosts.json";
const postData = blogPostsData.find(
  (p) => p.slug === "tour-virtual-google-mi-negocio",
);

useBlogSeo({
  title:
    "Tour Virtual en Google Business: Cómo Añadir Fotos 360° a tu Ficha | Travvir",
  description:
    "Guía completa para añadir fotos de 360° a tu Perfil de Google Business. Atrae más clientes, mejora tu SEO local y diferénciate de la competencia en 2026.",
  keywords:
    "tour virtual google business, fotos 360 google business, google mi negocio tour virtual, añadir fotos 360 google maps, recorrido virtual google business profile",
  slug: "tour-virtual-google-mi-negocio",
  image: postData.image,
  postData,
  faqItems: [
    {
      question:
        "¿Las herramientas de pano a imagen y pano a video son realmente gratis?",
      answer:
        "Sí. Las herramientas de pano a imagen y pano a video son siempre gratuitas en la app de Travvir.",
    },
  ],
});
</script>
